import React from 'react';

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import config from '@plone/registry';

const HeaderBrand = () => {
  const Logo = config.settings.iovisit.logo;

  return (
    <div className="iv--logo">
      <UniversalLink href="/" title={config.settings.iovisit.siteName}>
        <Logo />
        <div className="iv--brand-text">{config.settings.iovisit.siteName}</div>
      </UniversalLink>
    </div>
  );
};

export default HeaderBrand;
